import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ShareRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const resolve = async () => {
      try {
        const res = await api.get(`/share-links/${code}`);
        const link = res.data;
        if (link.target_path) {
          navigate(link.target_path, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        setError(true);
      }
    };
    resolve();
  }, [code, navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background p-6 text-center">
        <h1 className="font-heading text-3xl font-bold uppercase tracking-tight mb-2">Link Not Found</h1>
        <p className="text-muted-foreground mb-6">This share link may have expired or been removed.</p>
        <button onClick={() => navigate("/")} className="bg-court-orange hover:bg-court-orange-hover text-white rounded-full font-heading uppercase tracking-wide px-8 py-3">
          Go to SetPlay
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="animate-spin w-10 h-10 border-4 border-court-orange border-t-transparent rounded-full mb-4" />
      <p className="font-heading text-lg uppercase tracking-wide text-muted-foreground">Opening link...</p>
    </div>
  );
}
